import { useCallback, useEffect, useState } from 'react';
import {
  AppInput,
  AppRemixIcon,
  AppTextArea,
  AppModal,
  AppHelpModal,
  AppNoInfo,
} from '@/layout/AppComponents';
import styled from 'styled-components';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../../routing/helpers/router';
import colors from '../../../../../../constants/colors';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import CorrectiveActionsEditTask from './CorrectiveActions/CorrectiveActionsEditTask';
import Translator from '../../../../../components/helpers/Translator';
import CorrectiveActionsNewTask from './CorrectiveActions/CorrectiveActionsNewTask';
import CorrectiveActionsNewTaskUpdate from './CorrectiveActions/CorrectiveActionsNewTaskUpdate';
import CorrectiveActionsEditTaskUpdate from './CorrectiveActions/CorrectiveActionsEditTaskUpdate';
import CorrectiveActionsEditTaskUpdateCalcs from './CorrectiveActions/CorrectiveActionsEditTaskUpdateCalcs';
import AppLink from '../../../../../../routing/helpers/AppLink';
import efficacyValues from './PenaltyRisk/constants/efficacyValues';
import _ from 'lodash';

const CorrectiveActionsTab = (props) => {
  const { plantObligationID } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const permissions = useSelector(
    (state) => state.module[moduleBridgeHex].permissions
  );
  const tasks = useSelector(
    (s) => s.currentPage?.correctiveActionsTabs?.[plantObligationID]
  );
  const [showAddNewTask, setShowAddNewTask] = useState(false);
  const [showAddNewTaskUpdate, setShowAddNewTaskUpdate] = useState(false);
  const [showViewMultiTask, setShowViewMultiTask] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedTaskUpdate, setSelectedTaskUpdate] = useState(null);
  const [isEditTaskMode, setIsEditTaskMode] = useState(false);
  const [isEditTaskUpdateMode, setIsEditTaskUpdateMode] = useState(false);
  const [showEditCaCalc, setShowEditCaCalc] = useState(false);
  const [modulePermissions, setModulePermissions] = useState();
  const [allTasksWeight, setAllTasksWeight] = useState();
  const [hasTaskTypes, setHasTaskTypes] = useState();
  const [hasTaskUpdateTypes, setHasTaskUpdateTypes] = useState();
  const [multiTaskInfo, setMultiTaskInfo] = useState();
  const [caUserBridgeID, setCaUserBridgeID] = useState();
  const [poResidualProbability, setPoResidualProbability] = useState();

  useEffect(() => {
    if (tasks?.length > 0) {
      let weight = 0;
      _.map(tasks, (t) => {
        if (t.settings?.weight) weight += parseFloat(t.settings?.weight);
      });
      setAllTasksWeight(weight.toFixed(2));
    }
  }, [tasks]);
  // > LOAD CORRECTIVE ACTIONS TAB
  useEffect(() => {
    (async () => {
      try {
        const response = await axios.post(
          axiosPath("api_r_user_module_legalCompliance_correctiveActions_tab"),
          {
            moduleBridgeHex,
            plantHex,
            plantObligationID,
          }
        );
        dispatch(
          currentPageAction.change("correctiveActionsTabs", {
            [plantObligationID]: response.data.tasks,
          })
        );
        setModulePermissions(response.data.submodulePermissions);
        setHasTaskTypes(response.data.hasTaskTypes);
        setHasTaskUpdateTypes(response.data.hasTaskUpdateTypes);
        setCaUserBridgeID(response.data.caUserBridge);
        setPoResidualProbability(
          response.data?.poResidualProbability || undefined
        );
      } catch (err) {}
    })();
  }, []);
  // < LOAD CORRECTIVE ACTIONS TAB

  const handleDownloadTaskFile = async () => {
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_correctiveActions_task_downloadFile"
        ),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
          taskID: selectedTask.id,
        }
      );
      window.location = response.data;
    } catch (err) {}
  };

  const handleDownloadTaskUpdateFile = async () => {
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_correctiveActions_taskUpdate_downloadFile"
        ),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
          taskUpdateID: selectedTaskUpdate.id,
        }
      );
      window.location = response.data;
    } catch (err) {}
  };

  const handleChangeTaskStatus = async () => {
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_correctiveActions_task_changeState"
        ),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
          taskID: selectedTask.id,
        }
      );
      dispatch(
        currentPageAction.change(
          "correctiveActionsTabs",
          { [plantObligationID]: response.data },
          true
        )
      );
      setSelectedTask(null);
      setIsEditTaskMode(false);
    } catch (err) {}
  };
  const handleChangeTaskUpdateSupervisorStatus = async (state) => {
    try {
      const response = await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_correctiveActions_task_supervise"
        ),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
          taskID: selectedTask.id,
          taskUpdateID: selectedTaskUpdate.id,
          state,
        }
      );
      dispatch(
        currentPageAction.change(
          'correctiveActionsTabs',
          { [plantObligationID]: response.data },
          true
        )
      );
      setSelectedTask(null);
      setIsEditTaskMode(false);
    } catch (err) {}
  };

  const handleChangeTaskUpdateStatus = async () => {
    try {
      const response = await axios.post(
          axiosPath(
            'api_r_user_module_legalCompliance_correctiveActions_taskUpdate_changeState'
        ),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
          taskUpdateID: selectedTaskUpdate.id,
        }
      );
      dispatch(
        currentPageAction.change(
          'correctiveActionsTabs',
          { [plantObligationID]: response.data },
          true
        )
      );
      setSelectedTask(null);
      setSelectedTaskUpdate(null);
      setIsEditTaskMode(false);
      setIsEditTaskUpdateMode(false);
    } catch (err) {}
  };

  const handleMultiTask = async () => {
    setShowViewMultiTask(true);
    try {
      if (!multiTaskInfo) {
        const response = await axios.post(
            axiosPath(
              'api_r_user_module_legalCompliance_correctiveActions_task_getMultiList'
          ),
          {
            moduleBridgeHex,
            plantHex,
            taskId: selectedTask.id,
          }
        );
        setMultiTaskInfo(response.data);
      }
    } catch (err) {}
  };

  const renderPenaltyRisk = useCallback(() => {
    switch (permissions?.gcl?.module?.penaltyRisk?.type) {
      case 'acciona':
        return (
          <div className="row">
            <div className="col-lg-4">
              <AppInput
                title="Código"
                value={selectedTask?.accionaPenaltyRisk?.accionaPenaltyRiskCode}
                icon={<AppRemixIcon icon="calendar" />}
                isReadOnly
              />
            </div>
            <div className="col-lg-4">
              <AppInput
                title="Clasificación del control"
                value={
                  selectedTask?.accionaPenaltyRisk?.nature === 1
                    ? 'Detectivo'
                    : selectedTask?.accionaPenaltyRisk?.nature === 3
                    ? 'Preventivo'
                    : ''
                }
                icon={<AppRemixIcon icon="apps-2" />}
                isReadOnly
              />
            </div>
            <div className="col-lg-4">
              <AppInput
                title="Tipo de control"
                value={
                  selectedTask?.accionaPenaltyRisk?.automationLevel === 1
                    ? 'Manual'
                    : selectedTask?.accionaPenaltyRisk?.automationLevel === 3
                    ? 'Automático'
                    : 'Semiautomático'
                }
                icon={<AppRemixIcon icon="apps-2" />}
                isReadOnly
              />
            </div>
          </div>
        );
      case 'copisa':
        const implementationDregreeOptions = [
          {
            label: 'Implantado < 25 %',
            value: 0,
          },
          {
            label: 'Implantado en entre 25 % y 50 %',
            value: 0.25,
          },
          {
            label: 'Implantado en entre 50 % y 75 %',
            value: 0.5,
          },
          {
            label: 'Implantado en entre 75 % y 95 %',
            value: 0.75,
          },
          {
            label: 'Implantado en > 95 %',
            value: 1,
          },
        ];
        const efficiencyOptions = [
          {
            label: '0 puntos',
            value: 0,
          },
          {
            label: '1 punto',
            value: 0.2,
          },
          {
            label: '2 puntos',
            value: 0.4,
          },
          {
            label: '3 puntos',
            value: 0.6,
          },
          {
            label: '4 puntos',
            value: 0.8,
          },
          {
            label: '5 – 6 puntos',
            value: 1,
          },
        ];

        return (
          <div className="row">
            <div className="col-lg-4">
              <AppInput
                title="Grado de implentación"
                value={
                  implementationDregreeOptions.find(
                    (o) =>
                      o.value ===
                      selectedTask?.copisaPenaltyRisk
                        ?.copisaPenaltyRiskImplementationDregree
                  )?.label
                }
                icon={<AppRemixIcon icon="apps-2" />}
                isReadOnly
              />
            </div>
            <div className="col-lg-4 d-flex align-items-center">
              <AppInput
                title="Eficacia"
                value={
                  efficiencyOptions.find(
                    (o) =>
                      o.value ===
                      selectedTask?.copisaPenaltyRisk
                        ?.copisaPenaltyRiskEfficiency
                  )?.label
                }
                icon={<AppRemixIcon icon="apps-2" />}
                containerClassName="flex-grow-1"
                isReadOnly
              />
              <div className="ml-1">
                <AppHelpModal title="Ayuda" size="lg">
                  <div className="table-responsive">
                    <table className="table table-hover table-sm">
                      <thead>
                        <tr>
                          <th>Valor 0</th>
                          <th>Valor 1</th>
                        </tr>
                      </thead>
                      <tbody>
                        {efficacyValues.map((ev, i) => (
                          <tr key={i}>
                            <td>{ev.value0}</td>
                            <td>{ev.value1}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </AppHelpModal>
              </div>
            </div>
            <div className="col-lg-4">
              <AppInput
                icon={<AppRemixIcon icon="hashtag" noVariants />}
                title="Efectividad"
                value={
                  selectedTask?.copisaPenaltyRisk?.copisaPenaltyRiskEfficacy
                }
                isReadOnly
              />
            </div>
          </div>
        );
      default:
        return null;
    }
  }, [selectedTask]);

  if (!tasks) return <AppNoInfo minHeight={300} />;

  return (
    <CorrectiveActionsTabContainer>
      <SidebarMenu>
        <>
          {hasTaskTypes && (
            <span
              className="add-button"
              onClick={() => {
                setShowAddNewTask(true);
                setShowAddNewTaskUpdate(false);
                setSelectedTask(null);
                setSelectedTaskUpdate(false);
                setIsEditTaskMode(false);
                setIsEditTaskUpdateMode(false);
              }}
            >
              <Translator
                file="module-correctiveActions"
                name="module.ca.new-ca"
              />
              {` (${tasks.length})`}
            </span>
          )}
          {tasks.length > 0 ? (
            <>
              <ScrollBlock height="365px">
                <ul>
                  {tasks.length > 0 &&
                    tasks.map((task) => (
                      <li
                        style={{
                          borderLeftColor: task.closedStamp
                            ? colors.success
                            : task.status === 'danger'
                            ? colors.danger
                            : task.status === 'warning'
                            ? colors.state2
                            : colors.warning,
                        }}
                        key={task.id}
                        className={`task ${
                          selectedTask && selectedTask.id === task.id
                            ? 'ev-selected'
                            : ''
                        }`}
                        onClick={() => {
                          setShowAddNewTask(false);
                          setShowAddNewTaskUpdate(false);
                          setSelectedTask(task);
                          setSelectedTaskUpdate(false);
                          setIsEditTaskMode(false);
                          setIsEditTaskUpdateMode(false);
                        }}
                      >
                        <div className="first-row">
                          <span
                            className="name"
                            dangerouslySetInnerHTML={{
                              __html: task.comment?.replace(/<[^>]*>?/gm, ''),
                            }}
                          ></span>
                          {/* <span>{task.user}</span> */}
                        </div>
                        <div className="second-row">
                          {permissions?.gcl?.module?.penaltyRisk?.type ===
                          'acciona' ? (
                            <span
                              className="sr-date"
                              title={ReactDOMServer.renderToString(
                                <Translator
                                  file="module-correctiveActions"
                                  name="module.ca.code"
                                />
                              )}
                            >
                              {task?.accionaPenaltyRisk
                                ?.accionaPenaltyRiskCode || '-'}
                            </span>
                          ) : (
                            <>
                              <span
                                className="sr-date"
                                title={ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-legalCompliance"
                                    name="module.lc.limit.date"
                                  />
                                )}
                              >
                                {task.limitDate}
                              </span>
                              <span
                                className="sr-date"
                                title={ReactDOMServer.renderToString(
                                  <Translator
                                    file="module-correctiveActions"
                                    name="module.ca.closedStamp"
                                  />
                                )}
                              >
                                {task?.closedStamp}
                              </span>
                            </>
                          )}
                          {permissions.gcl?.module?.submodules
                            ?.correctiveActions?.taskMultiObligation &&
                            task.isMulti && (
                              <span>
                                <AppRemixIcon icon="checkbox-multiple-blank" />
                              </span>
                            )}
                          {task.blocked && (
                            <span>
                              <AppRemixIcon icon="lock" />
                            </span>
                          )}
                        </div>
                      </li>
                    ))}
                </ul>
              </ScrollBlock>
              {modulePermissions?.caAutoCalc &&
                modulePermissions.caAutoCalc == 1 &&
                allTasksWeight != '1.00' && (
                  <span
                    className="add-button text-danger"
                    title={ReactDOMServer.renderToString(
                      <Translator
                        file="module-legalCompliance"
                        name="inconsistency.task.weight"
                        variables={{ allTasksWeight }}
                      />
                    )}
                  >
                    <AppRemixIcon icon="alert" className="mr-2" />
                    <Translator
                      file="module-legalCompliance"
                      name="inconsistency.weight"
                      variables={{ allTasksWeight }}
                    />
                  </span>
                )}
            </>
          ) : (
            <AppNoInfo
              text={ReactDOMServer.renderToString(
                <Translator
                  file="module-legalCompliance"
                  name="without.tasks"
                />
              )}
              color={colors.primaryLight}
              icon={
                <AppRemixIcon
                  size={24}
                  icon="file-search"
                  color={colors.primaryLight}
                />
              }
            />
          )}
        </>
      </SidebarMenu>
      <Content>
        {showAddNewTask ? (
          <CorrectiveActionsNewTask
            plantObligationID={plantObligationID}
            onCreated={() => setShowAddNewTask(false)}
            modulePermissions={modulePermissions}
          />
        ) : showAddNewTaskUpdate ? (
          <CorrectiveActionsNewTaskUpdate
            plantObligationID={plantObligationID}
            onCreated={() => {
              setShowAddNewTaskUpdate(false);
              setSelectedTask(null);
            }}
            modulePermissions={modulePermissions}
            selectedTask={selectedTask}
          />
        ) : (
          <>
            {selectedTask ? (
              <div>
                {isEditTaskMode ? (
                  <CorrectiveActionsEditTask
                    plantObligationID={plantObligationID}
                    selectedTask={selectedTask}
                    modulePermissions={modulePermissions}
                    onCreated={() => {
                      setSelectedTask(null);
                      setIsEditTaskMode(false);
                      setIsEditTaskUpdateMode(false);
                      setSelectedTaskUpdate(false);
                    }}
                  />
                ) : (
                  <>
                    <h3>
                      <Translator
                        file="module-legalCompliance"
                        name="task.code"
                        variables={{ taskCode: selectedTask.code }}
                      />
                      <AppRemixIcon
                        icon="close"
                        className="float-right pointer mr-2"
                        size={16}
                        onClick={() => {
                          setSelectedTask(null);
                          setIsEditTaskMode(false);
                          setIsEditTaskUpdateMode(false);
                          setSelectedTaskUpdate(false);
                        }}
                      />
                      {!selectedTask.blocked && (
                        <>
                          <AppRemixIcon
                            icon="edit"
                            className="float-right pointer mr-2"
                            size={16}
                            onClick={() => setIsEditTaskMode(true)}
                          />
                          <AppRemixIcon
                            icon={
                              selectedTask.closedStamp
                                ? 'arrow-go-back'
                                : 'checkbox'
                            }
                            className="float-right pointer mr-2"
                            size={16}
                            color={colors.success}
                            title={
                              selectedTask.closedStamp
                                ? 'Reabrir tarea'
                                : 'Cerrar tarea'
                            }
                            onClick={() => handleChangeTaskStatus()}
                          />
                        </>
                      )}

                      {permissions.gcl?.module?.submodules?.correctiveActions
                        ?.taskMultiObligation &&
                        selectedTask.isMulti && (
                          <>
                            <AppModal
                              show={showViewMultiTask}
                              onClose={() => setShowViewMultiTask(false)}
                              title={`Listado de obligaciones con tarea ${selectedTask.code} asignada`}
                              size="xl"
                            >
                              {multiTaskInfo ? (
                                <table className="table table-hover table-sm">
                                  <thead>
                                    <tr>
                                      <th className="col-lg-9">
                                        <Translator
                                          file="module-intelligence"
                                          name="plant"
                                        />
                                      </th>
                                      <th className="col-lg-3">
                                        <Translator
                                          file="evaluation"
                                          name="obligation.name"
                                        />
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {multiTaskInfo.map((e) => (
                                      <tr key={e.obligation.hex}>
                                        <td>
                                          {e.plant.userPermission ? (
                                            <AppLink
                                              path="user_module_legalCompliance_evaluation"
                                              params={{
                                                moduleBridgeHex,
                                                plantHex: e.plant.hex,
                                                page: 1,
                                                filtersHex: 0,
                                              }}
                                            >
                                              {e.plant.name}
                                            </AppLink>
                                          ) : (
                                            e.plant.name
                                          )}
                                        </td>
                                        <td>{e.obligation.hex}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              ) : (
                                <AppNoInfo minHeight={100} />
                              )}
                            </AppModal>
                            <AppRemixIcon
                              icon="checkbox-multiple-blank"
                              className="float-right pointer mr-2"
                              size={16}
                              title="Ver tareas vinculadas"
                              onClick={() => handleMultiTask()}
                            />
                          </>
                        )}
                    </h3>
                    <CorrectiveActionsTaskContainer>
                      <SidebarMenu
                        $hasTaskUpdateClosedSystem={
                          permissions.gcl?.module?.submodules?.correctiveActions
                            ?.taskUpdateClosedSystem
                        }
                      >
                        <>
                          {hasTaskUpdateTypes && !selectedTask.blocked && (
                            <span
                              className="add-button"
                              onClick={() => {
                                setShowAddNewTaskUpdate(true);
                                setSelectedTaskUpdate(false);
                              }}
                            >
                              <Translator
                                file="module-legalCompliance"
                                name="add.action"
                              />
                            </span>
                          )}
                          {selectedTask?.taskUpdates?.length > 0 ? (
                            <ScrollBlock height="360px">
                              <ul>
                                {selectedTask?.taskUpdates?.length > 0 &&
                                  selectedTask?.taskUpdates.map(
                                    (taskUpdate) => (
                                      <li
                                        style={{
                                          borderLeftColor: taskUpdate.closedStamp
                                            ? colors.success
                                            : taskUpdate.status === 'danger'
                                            ? colors.danger
                                            : taskUpdate.status === 'warning'
                                            ? colors.state2
                                            : colors.warning,
                                        }}
                                        key={taskUpdate.id}
                                        className={
                                          selectedTaskUpdate &&
                                          selectedTaskUpdate.id ===
                                            taskUpdate.id
                                            ? 'ev-selected'
                                            : ''
                                        }
                                        onClick={() => {
                                          setShowAddNewTask(false);
                                          setShowAddNewTaskUpdate(false);
                                          setShowAddNewTaskUpdate(false);
                                          setSelectedTaskUpdate(taskUpdate);
                                          setIsEditTaskUpdateMode(false);
                                        }}
                                      >
                                        <div className="first-row">
                                          <span
                                            className="name"
                                            title={taskUpdate.date}
                                          >
                                            {taskUpdate.date}
                                          </span>
                                          <span>
                                            {permissions.gcl?.module?.submodules
                                              ?.correctiveActions
                                              ?.supervisionSystem
                                              ? taskUpdate?.controlUser?.name
                                              : taskUpdate.user}
                                          </span>
                                        </div>
                                        <div className="second-row">
                                          <span className="sr-date">
                                            {taskUpdate.type.name}
                                          </span>
                                        </div>
                                      </li>
                                    )
                                  )}
                              </ul>
                            </ScrollBlock>
                          ) : (
                            <>
                              {hasTaskUpdateTypes && (
                                <AppNoInfo
                                  text={ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-legalCompliance"
                                      name="without.actions"
                                    />
                                  )}
                                  color={colors.primaryLight}
                                  icon={
                                    <AppRemixIcon
                                      size={24}
                                      icon="file-search"
                                      color={colors.primaryLight}
                                    />
                                  }
                                />
                              )}
                            </>
                          )}
                        </>
                      </SidebarMenu>
                      <ContentTask>
                        {selectedTaskUpdate ? (
                          isEditTaskUpdateMode ? (
                            <CorrectiveActionsEditTaskUpdate
                              plantObligationID={plantObligationID}
                              selectedTask={selectedTask}
                              selectedTaskUpdate={selectedTaskUpdate}
                              modulePermissions={modulePermissions}
                              caUserBridgeID={caUserBridgeID}
                              onCreated={(r) => {
                                setSelectedTask(null);
                                setIsEditTaskMode(false);
                                setIsEditTaskUpdateMode(false);
                                setSelectedTaskUpdate(false);
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                borderTop: `1px solid ${colors.grey300}`,
                              }}
                              className="pt-2"
                            >
                              <h3>
                                {`Acción ${selectedTaskUpdate.date} - ${selectedTaskUpdate.type.name} - ${selectedTaskUpdate.user}`}
                                <AppRemixIcon
                                  icon="close"
                                  className="float-right pointer mr-2"
                                  size={16}
                                  onClick={() => {
                                    setIsEditTaskMode(false);
                                    setIsEditTaskUpdateMode(false);
                                    setSelectedTaskUpdate(false);
                                  }}
                                />
                                {!selectedTask.blocked && (
                                  <>
                                    {!selectedTaskUpdate.closedStamp && (
                                      <AppRemixIcon
                                        icon="edit"
                                        className="float-right pointer mr-2"
                                        size={16}
                                        onClick={() =>
                                          setIsEditTaskUpdateMode(true)
                                        }
                                      />
                                    )}
                                    {permissions.gcl?.module?.submodules
                                      ?.correctiveActions
                                      ?.taskUpdateClosedSystem && (
                                      <AppRemixIcon
                                        icon={
                                          selectedTaskUpdate.closedStamp
                                            ? 'arrow-go-back'
                                            : 'checkbox'
                                        }
                                        className="float-right pointer mr-2"
                                        size={16}
                                        color={colors.success}
                                        title={
                                          selectedTask.closedStamp
                                            ? 'Reabrir acción'
                                            : 'Cerrar acción'
                                        }
                                        onClick={() =>
                                          handleChangeTaskUpdateStatus()
                                        }
                                      />
                                    )}
                                    {modulePermissions?.caAutoCalc &&
                                      modulePermissions.caAutoCalc == 1 && (
                                        <>
                                          {!selectedTaskUpdate.closedStamp && (
                                            <AppRemixIcon
                                              icon="pencil-ruler-2"
                                              title={ReactDOMServer.renderToString(
                                                <Translator
                                                  file="module-legalCompliance"
                                                  name="edit.implementation.and.efficiency"
                                                />
                                              )}
                                              className="float-right pointer mr-2"
                                              size={16}
                                              onClick={() =>
                                                setShowEditCaCalc(true)
                                              }
                                            />
                                          )}
                                          <AppModal
                                            show={showEditCaCalc}
                                            title={ReactDOMServer.renderToString(
                                              <Translator
                                                file="module-legalCompliance"
                                                name="edit.implementation.and.efficiency"
                                              />
                                            )}
                                            onClose={() =>
                                              setShowEditCaCalc(false)
                                            }
                                          >
                                            <CorrectiveActionsEditTaskUpdateCalcs
                                              plantObligationID={
                                                plantObligationID
                                              }
                                              selectedTask={selectedTask}
                                              selectedTaskUpdate={
                                                selectedTaskUpdate
                                              }
                                              modulePermissions={
                                                modulePermissions
                                              }
                                              onCreated={(r) => {
                                                setSelectedTask(null);
                                                setIsEditTaskMode(false);
                                                setIsEditTaskUpdateMode(false);
                                                setSelectedTaskUpdate(false);
                                                setShowEditCaCalc(false);
                                              }}
                                            />
                                          </AppModal>
                                        </>
                                      )}
                                  </>
                                )}
                              </h3>
                              <div className="row-no-margin">
                                <div className="row">
                                  {permissions.gcl?.module?.submodules
                                    ?.correctiveActions
                                    ?.taskUpdateClosedSystem ? (
                                    <>
                                      <div className="col-lg-4 col-md-12">
                                        <AppInput
                                          title={ReactDOMServer.renderToString(
                                            <Translator
                                              file="module-legalCompliance"
                                              name="module.lc.export.ob.date"
                                            />
                                          )}
                                          value={selectedTaskUpdate.date}
                                          icon={
                                            <AppRemixIcon icon="calendar" />
                                          }
                                          isReadOnly
                                        />
                                      </div>
                                      <div className="col-lg-4 col-md-12">
                                        {selectedTaskUpdate.closedStamp ? (
                                          <AppInput
                                            title={ReactDOMServer.renderToString(
                                              <Translator
                                                file="module-correctiveActions"
                                                name="module.ca.closedStamp"
                                              />
                                            )}
                                            value={
                                              selectedTaskUpdate.closedStamp
                                            }
                                            icon={
                                              <AppRemixIcon icon="calendar" />
                                            }
                                            isReadOnly
                                          />
                                        ) : (
                                          <AppInput
                                            title={ReactDOMServer.renderToString(
                                              <Translator
                                                file="module-legalCompliance"
                                                name="module.lc.limit.date"
                                              />
                                            )}
                                            value={selectedTaskUpdate.limitDate}
                                            icon={
                                              <AppRemixIcon icon="calendar" />
                                            }
                                            isReadOnly
                                          />
                                        )}
                                      </div>
                                      <div className="col-lg-4 col-md-12">
                                        <AppInput
                                          title={ReactDOMServer.renderToString(
                                            <Translator
                                              file="module-correctiveActions"
                                              name="module.ca.task-type-2"
                                            />
                                          )}
                                          value={selectedTaskUpdate.type.name}
                                          icon={
                                            <AppRemixIcon
                                              icon="list-check"
                                              noVariants
                                            />
                                          }
                                          isReadOnly
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="col-lg-6 col-md-12">
                                        <AppInput
                                          title={ReactDOMServer.renderToString(
                                            <Translator
                                              file="module-legalCompliance"
                                              name="module.lc.export.ob.date"
                                            />
                                          )}
                                          value={selectedTaskUpdate.date}
                                          icon={
                                            <AppRemixIcon icon="calendar" />
                                          }
                                          isReadOnly
                                        />
                                      </div>
                                      <div className="col-lg-6 col-md-12">
                                        <AppInput
                                          title={ReactDOMServer.renderToString(
                                            <Translator
                                              file="module-correctiveActions"
                                              name="module.ca.task-type-2"
                                            />
                                          )}
                                          value={selectedTaskUpdate.type.name}
                                          icon={
                                            <AppRemixIcon
                                              icon="list-check"
                                              noVariants
                                            />
                                          }
                                          isReadOnly
                                        />
                                      </div>
                                    </>
                                  )}
                                </div>
                                {permissions.gcl?.module?.submodules
                                  ?.correctiveActions?.supervisionSystem && (
                                  <div className="row">
                                    <div className="col-lg-12">
                                      <AppInput
                                        title={ReactDOMServer.renderToString(
                                          <Translator
                                            file="module-legalCompliance"
                                            name="owner"
                                          />
                                        )}
                                        value={
                                          selectedTaskUpdate.controlUser ? (
                                            <span
                                              title={
                                                selectedTaskUpdate.controlUser
                                                  .user
                                              }
                                            >
                                              {
                                                selectedTaskUpdate.controlUser
                                                  .name
                                              }
                                              :
                                              <span
                                                className={`pl-1 ${
                                                  selectedTaskUpdate.controlUserStatus ===
                                                  1
                                                    ? 'text-success'
                                                    : 'text-warning'
                                                }`}
                                              >
                                                {selectedTaskUpdate.controlUserStatus ===
                                                1
                                                  ? ReactDOMServer.renderToString(
                                                      <Translator
                                                        file="module-correctiveActions"
                                                        name="accepted"
                                                      />
                                                    )
                                                  : ReactDOMServer.renderToString(
                                                      <Translator
                                                        file="module-correctiveActions"
                                                        name="not.accepted"
                                                      />
                                                    )}
                                              </span>
                                            </span>
                                          ) : (
                                            ''
                                          )
                                        }
                                        icon={<AppRemixIcon icon="user" />}
                                        isReadOnly
                                      />
                                    </div>
                                  </div>
                                )}
                                {permissions.gcl?.module?.submodules
                                  ?.correctiveActions?.supervisionSystem && (
                                  <div className="row">
                                    <div
                                      className={`col-lg-${
                                        selectedTaskUpdate.controlSupervisor
                                          ?.userBridgeID === caUserBridgeID
                                          ? '10'
                                          : '12'
                                      } pr-0`}
                                    >
                                      <AppInput
                                        title={ReactDOMServer.renderToString(
                                          <Translator
                                            file="module-correctiveActions"
                                            name="supervisor"
                                          />
                                        )}
                                        value={
                                          selectedTaskUpdate.controlSupervisor ? (
                                            <span
                                              title={
                                                selectedTaskUpdate
                                                  .controlSupervisor.user
                                              }
                                            >
                                              {
                                                selectedTaskUpdate
                                                  .controlSupervisor.name
                                              }
                                              :
                                              <span
                                                className={`pl-1 ${
                                                  selectedTaskUpdate.controlSupervisorStatus ===
                                                  0
                                                    ? 'text-black'
                                                    : selectedTaskUpdate.controlSupervisorStatus ===
                                                      1
                                                    ? 'text-success'
                                                    : selectedTaskUpdate.controlSupervisorStatus ===
                                                      2
                                                    ? 'text-danger'
                                                    : 'text-warning'
                                                }`}
                                              >
                                                {selectedTaskUpdate.controlSupervisorStatus ===
                                                0
                                                  ? 'Pendiente'
                                                  : selectedTaskUpdate.controlSupervisorStatus ===
                                                    1
                                                  ? 'Aprobado'
                                                  : selectedTaskUpdate.controlSupervisorStatus ===
                                                    2
                                                  ? 'Declinado'
                                                  : 'Sin supervisión'}
                                              </span>
                                            </span>
                                          ) : (
                                            ''
                                          )
                                        }
                                        icon={<AppRemixIcon icon="user" />}
                                        isReadOnly
                                      />
                                    </div>
                                    {selectedTaskUpdate.controlSupervisor
                                      ?.userBridgeID === caUserBridgeID && (
                                      <>
                                        <div className="col-lg-1 pl-1 pr-0">
                                          <span
                                            className={`btn btn-success btn-sm btn-block ${
                                              selectedTaskUpdate.controlUserStatus ===
                                                0 ||
                                              selectedTaskUpdate
                                                .controlSupervisor
                                                .userBridgeID !== caUserBridgeID
                                                ? 'disabled'
                                                : ''
                                            }`}
                                            style={{ marginTop: '11px' }}
                                            title="Aprobar"
                                            onClick={() =>
                                              selectedTaskUpdate.controlUserStatus ===
                                                1 &&
                                              selectedTaskUpdate
                                                .controlSupervisor
                                                .userBridgeID ===
                                                caUserBridgeID &&
                                              handleChangeTaskUpdateSupervisorStatus(
                                                true
                                              )
                                            }
                                          >
                                            <AppRemixIcon icon="thumb-up" />
                                          </span>
                                        </div>
                                        <div className="col-lg-1 pl-1">
                                          <span
                                            className={`btn btn-danger btn-sm btn-block ${
                                              selectedTaskUpdate.controlUserStatus ===
                                                0 ||
                                              selectedTaskUpdate
                                                .controlSupervisor
                                                .userBridgeID !== caUserBridgeID
                                                ? 'disabled'
                                                : ''
                                            }`}
                                            style={{ marginTop: '11px' }}
                                            title="Declinar"
                                            onClick={() =>
                                              selectedTaskUpdate.controlUserStatus ===
                                                1 &&
                                              selectedTaskUpdate
                                                .controlSupervisor
                                                .userBridgeID ===
                                                caUserBridgeID &&
                                              handleChangeTaskUpdateSupervisorStatus(
                                                false
                                              )
                                            }
                                          >
                                            <AppRemixIcon icon="thumb-down" />
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                              <div className="row-no-margin">
                                <div className="row">
                                  <div className="col-lg-8">
                                    <AppTextArea
                                      title={ReactDOMServer.renderToString(
                                        <Translator
                                          file="module-correctiveActions"
                                          name="module.ca.description"
                                        />
                                      )}
                                      value={
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              selectedTaskUpdate.description,
                                          }}
                                        />
                                      }
                                      icon={
                                        <AppRemixIcon
                                          icon="double-quotes-l"
                                          noVariants
                                        />
                                      }
                                      height={
                                        modulePermissions?.caAutoCalc &&
                                        modulePermissions.caAutoCalc == 1
                                          ? '150px'
                                          : '204px'
                                      }
                                      isReadOnly
                                    />
                                  </div>
                                  <div className="col-lg-4">
                                    {!permissions.gcl?.module?.submodules
                                      ?.correctiveActions
                                      ?.supervisionSystem && (
                                      <AppTextArea
                                        title={ReactDOMServer.renderToString(
                                          <Translator
                                            file="module-legalCompliance"
                                            name="responsibles"
                                          />
                                        )}
                                        value={
                                          <ul style={{ paddingLeft: '6px' }}>
                                            {selectedTaskUpdate.responsibles.map(
                                              (r, i) => (
                                                <li
                                                  key={i}
                                                  title={ReactDOMServer.renderToString(
                                                    <Translator
                                                      file="module-legalCompliance"
                                                      name="responsible"
                                                    />
                                                  )}
                                                >
                                                  {r.name}
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        }
                                        icon={<AppRemixIcon icon="user" />}
                                        height={
                                          modulePermissions?.caAutoCalc &&
                                          modulePermissions.caAutoCalc == 1
                                            ? '107px'
                                            : '160px'
                                        }
                                        isReadOnly
                                      />
                                    )}
                                    <AppInput
                                      title={ReactDOMServer.renderToString(
                                        <Translator
                                          file="user"
                                          name="user.obligation.evidence.file"
                                        />
                                      )}
                                      value={
                                        selectedTaskUpdate.file ? (
                                          <span
                                            className="pointer text-info"
                                            onClick={() =>
                                              handleDownloadTaskUpdateFile()
                                            }
                                          >
                                            {selectedTaskUpdate.file?.url}
                                          </span>
                                        ) : (
                                          <span className="text-muted">
                                            Sin archivo
                                          </span>
                                        )
                                      }
                                      icon={<AppRemixIcon icon="file" />}
                                      isReadOnly
                                    />
                                  </div>
                                </div>
                              </div>
                              {modulePermissions?.caAutoCalc &&
                                modulePermissions.caAutoCalc == 1 && (
                                  <div className="row-no-margin">
                                    <div className="row">
                                      <div className="col-lg-4">
                                        <AppInput
                                          title={ReactDOMServer.renderToString(
                                            <Translator
                                              file="module-legalCompliance"
                                              name="implementation"
                                            />
                                          )}
                                          value={
                                            selectedTaskUpdate.settings
                                              ?.implantation
                                          }
                                          icon={
                                            <AppRemixIcon icon="line-chart" />
                                          }
                                          isReadOnly
                                        />
                                      </div>
                                      <div className="col-lg-4">
                                        <AppInput
                                          title={ReactDOMServer.renderToString(
                                            <Translator
                                              file="module-correctiveActions"
                                              name="efficacy"
                                            />
                                          )}
                                          value={
                                            selectedTaskUpdate.settings
                                              ?.efficacy
                                          }
                                          icon={
                                            <AppRemixIcon icon="line-chart" />
                                          }
                                          isReadOnly
                                        />
                                      </div>
                                      <div className="col-lg-4">
                                        <AppInput
                                          title={ReactDOMServer.renderToString(
                                            <Translator
                                              file="module-correctiveActions"
                                              name="effectiveness"
                                            />
                                          )}
                                          value={
                                            selectedTaskUpdate.settings
                                              ?.effectiveness
                                          }
                                          icon={
                                            <AppRemixIcon icon="line-chart" />
                                          }
                                          isReadOnly
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}
                            </div>
                          )
                        ) : (
                          <div className="row-no-margin">
                            <div className="row">
                              <div className="col-xl-3 col-lg-12 col-md-12">
                                <AppInput
                                  title={ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-legalCompliance"
                                      name="module.lc.export.ob.date"
                                    />
                                  )}
                                  value={selectedTask.date}
                                  icon={<AppRemixIcon icon="calendar" />}
                                  isReadOnly
                                />
                              </div>
                              <div className="col-xl-3 col-lg-12 col-md-12">
                                <AppInput
                                  title={ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-correctiveActions"
                                      name="module.ca.closedStamp"
                                    />
                                  )}
                                  value={selectedTask.closedStamp}
                                  icon={<AppRemixIcon icon="calendar" />}
                                  isReadOnly
                                />
                              </div>
                              <div className="col-xl-3 col-lg-12 col-md-12">
                                <AppInput
                                  title={ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-legalCompliance"
                                      name="module.lc.limit.date"
                                    />
                                  )}
                                  value={selectedTask.limitDate}
                                  icon={<AppRemixIcon icon="calendar" />}
                                  isReadOnly
                                />
                              </div>
                              <div className="col-xl-3 col-lg-12 col-md-12">
                                <AppInput
                                  title={ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-correctiveActions"
                                      name="module.ca.gcl-task-type"
                                    />
                                  )}
                                  value={selectedTask.type?.name}
                                  icon={<AppRemixIcon icon="focus" />}
                                  isReadOnly
                                />
                              </div>
                            </div>
                            {modulePermissions?.caAutoCalc &&
                              modulePermissions.caAutoCalc == 1 && (
                                <div className="row">
                                  <div className="col-xl-3 col-lg-6 col-md-12">
                                    <AppInput
                                      title={ReactDOMServer.renderToString(
                                        <Translator
                                          file="module-correctiveActions"
                                          name="initial.probability"
                                        />
                                      )}
                                      value={
                                        selectedTask.settings
                                          ?.initialProbability !== undefined ? (
                                          <Translator
                                            file="filter"
                                            name={`filter.probability.${selectedTask.settings?.initialProbability}`}
                                          />
                                        ) : (
                                          '--'
                                        )
                                      }
                                      icon={<AppRemixIcon icon="calendar" />}
                                      isReadOnly
                                    />
                                  </div>
                                  <div className="col-xl-3 col-lg-6 col-md-12">
                                    <AppInput
                                      title={ReactDOMServer.renderToString(
                                        <Translator
                                          file="module-correctiveActions"
                                          name="weight"
                                        />
                                      )}
                                      value={
                                        selectedTask.settings?.weight || '--'
                                      }
                                      icon={<AppRemixIcon icon="calendar" />}
                                      isReadOnly
                                    />
                                  </div>
                                  <div className="col-xl-3 col-lg-6 col-md-12">
                                    <AppInput
                                      title={
                                        <Translator
                                          file="module-correctiveActions"
                                          name="effectiveness.average"
                                        />
                                      }
                                      value={
                                        selectedTask.settings
                                          ?.effectivenessAverage || '--'
                                      }
                                      icon={<AppRemixIcon icon="focus" />}
                                      isReadOnly
                                    />
                                  </div>
                                  <div className="col-xl-3 col-lg-6 col-md-12">
                                    <AppInput
                                      title={ReactDOMServer.renderToString(
                                        <Translator
                                          file="module-correctiveActions"
                                          name="residual.probability"
                                        />
                                      )}
                                      value={
                                        selectedTask.settings
                                          ?.residualProbability || '--'
                                      }
                                      icon={<AppRemixIcon icon="focus" />}
                                      isReadOnly
                                    />
                                  </div>
                                </div>
                              )}
                            {renderPenaltyRisk()}
                            <div className="row">
                              <div className="col-xl-8 col-lg-12 col-md-12">
                                <AppTextArea
                                  title={ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-correctiveActions"
                                      name="module.ca.description"
                                    />
                                  )}
                                  icon={
                                    <AppRemixIcon
                                      icon="double-quotes-l"
                                      noVariants
                                    />
                                  }
                                  height="230px"
                                  value={
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: selectedTask.comment,
                                      }}
                                    />
                                  }
                                  isReadOnly
                                />
                              </div>
                              <div className="col-xl-4 col-lg-12 col-md-12">
                                {!permissions.gcl?.module?.submodules
                                  ?.correctiveActions?.supervisionSystem && (
                                  <AppTextArea
                                    title={ReactDOMServer.renderToString(
                                      <Translator
                                        file="module-legalCompliance"
                                        name="responsibles"
                                      />
                                    )}
                                    icon={<AppRemixIcon icon="user" />}
                                    height="186px"
                                    value={
                                      <ul style={{ paddingLeft: '6px' }}>
                                        {selectedTask.responsibles &&
                                          selectedTask.responsibles.map(
                                            (r, i) => (
                                              <li key={i} title="Responsable">
                                                {r.name}
                                              </li>
                                            )
                                          )}
                                        {selectedTask.externalResponsibles &&
                                          selectedTask.externalResponsibles
                                            .split(',')
                                            .map((er, i) => (
                                              <li
                                                key={i}
                                                title={ReactDOMServer.renderToString(
                                                  <Translator
                                                    file="module-legalCompliance"
                                                    name="external.responsible"
                                                  />
                                                )}
                                                className="text-info"
                                              >
                                                {er}
                                              </li>
                                            ))}
                                      </ul>
                                    }
                                    isReadOnly
                                  />
                                )}
                                <AppInput
                                  title={ReactDOMServer.renderToString(
                                    <Translator
                                      file="user"
                                      name="user.obligation.evidence.file"
                                    />
                                  )}
                                  value={
                                    selectedTask.file ? (
                                      <span
                                        className="pointer text-info"
                                        onClick={() => handleDownloadTaskFile()}
                                      >
                                        {selectedTask.file.url}
                                      </span>
                                    ) : (
                                      <span className="text-muted">
                                        <Translator
                                          file="module-correctiveActions"
                                          name="without.file"
                                        />
                                      </span>
                                    )
                                  }
                                  icon={<AppRemixIcon icon="file" />}
                                  isReadOnly
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </ContentTask>
                    </CorrectiveActionsTaskContainer>
                  </>
                )}
              </div>
            ) : (
              <>
                {permissions.gcl?.module?.submodules?.correctiveActions
                  ?.supervisionSystem ? (
                  <SupervisionSystemInfoContainer>
                    <div className="data m-2 p-2">
                      <ul className="list-group mb-2">
                        <li className="list-group-item">
                          <b>{`${poResidualProbability} = `}</b>
                          {tasks?.map((t, i) => (
                            <span key={i}>
                              {t.settings?.residualProbability || '0.00'}
                              {i < tasks.length - 1 ? ' + ' : ''}
                            </span>
                          ))}
                        </li>
                      </ul>
                      <ul className="list-group">
                        {tasks?.map((t, i) => (
                          <li key={i} className="list-group-item">
                            <b>{t.code}</b>
                            {`: ${
                              t.settings?.residualProbability
                                ? `${t.settings?.residualProbability} = ${t
                                    .settings?.initialProbability + 1} * ${
                                    t.settings?.weight
                                  } * (1 - ${t.settings?.effectivenessAverage})`
                                : 'Sin datos'
                            }`}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="legend m-2 p-2">
                      P = Pe1 + Pe2 + Pe3…+ Pe(n)
                      <br />
                      <br />
                      Donde:
                      <br />
                      P = Probabilidad residual del delito una vez aplicados los
                      controles.
                      <br />
                      Pe(n) = Probabilidad residual de cada escenario
                      <hr />
                      Pe(x) = Pd*Peso*(1 – Efcontrol)
                      <br />
                      <br />
                      Donde:
                      <br />
                      Pe(x) = Probabilidad residual del escenario x
                      <br />
                      Pd = Probabilidad inicial al delito
                      <br />
                      Peso = Valor de ponderación del escenario (0 – 1)
                      <br />
                      Efcontrol = Efectividad del control (0 – 1)
                      <br />
                      <br />
                      <table>
                        <thead>
                          <tr>
                            <th>Nivel</th>
                            <th>Criterio</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Muy Baja (1)</td>
                            <td>P ≤ 1</td>
                          </tr>
                          <tr>
                            <td>Baja (2)</td>
                            <td>{'1 < P ≤ 2'}</td>
                          </tr>
                          <tr>
                            <td>Media (3)</td>
                            <td>{'2 < P ≤ 3'}</td>
                          </tr>
                          <tr>
                            <td>Alta (4)</td>
                            <td>{'3 < P ≤ 4'}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </SupervisionSystemInfoContainer>
                ) : (
                  <AppNoInfo
                    text={
                      <span>
                        <Translator
                          file="module-legalCompliance"
                          name="select.task.list.create.button.new.task"
                          isHtml
                        />
                      </span>
                    }
                    color={colors.primaryLight}
                    icon={
                      <AppRemixIcon
                        size={40}
                        icon="calendar-check"
                        color={colors.primaryLight}
                      />
                    }
                  />
                )}
              </>
            )}
          </>
        )}
      </Content>
    </CorrectiveActionsTabContainer>
  );
};
export default CorrectiveActionsTab;

const CorrectiveActionsTabContainer = styled.div`
  height: 400px;
  display: grid;
  grid-template-columns: 260px 1fr;
`;

const CorrectiveActionsTaskContainer = styled.div`
  margin-top: 15px;
  height: 360px;
  display: grid;
  grid-template-columns: 230px 1fr;
`;

const SupervisionSystemInfoContainer = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 0.5fr;
  div {
    border: 1px solid #ddd;
  }
  td {
    border: 1px solid #ddd;
    border-collapse: collapse;
  }
  .data,
  .legend {
    height: 360px;
    overflow-y: auto;
    font-size: 12px;
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      font-size: 14px;
    }
  }
`;

const SidebarMenu = styled.div`
  overflow-y: auto;
  padding: 0;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .add-button {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${colors.primary};
    color: ${colors.primary};
    margin: 0;
    height: 32px;
    cursor: pointer;
  }
  ul {
    padding: 4px;
    overflow-y: auto;
    li {
      &.task {
        border-left-width: 6px;
        border-left-style: solid;
        .first-row {
          padding-left: 6px;
          max-height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 235px;
          span {
            padding-right: 4px;
          }
        }
      }
      ${(props) =>
        props.$hasTaskUpdateClosedSystem &&
        'border-left-width: 6px; border-left-style: solid;'}
      padding: 4px 6px 4px 4px;
      border-bottom: 1px solid ${colors.grey300};
      cursor: pointer;
      &.ev-selected {
        background: ${colors.grey300};
      }
      .first-row {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        color: ${colors.primary};
        .name {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .second-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 10px;
        .sr-date {
          letter-spacing: 1px;
        }
        .sr-user {
          color: ${colors.primary};
        }
      }
    }
  }
`;

const Content = styled.div`
  overflow-y: auto;
  border-left: 1px solid ${colors.grey300};
  padding: 4px;
  height: 400px;
  .row-no-margin > .row {
    margin: 0;
  }
`;

const ContentTask = styled.div`
  overflow-y: auto;
  border-left: 1px solid ${colors.grey300};
  padding: 4px;
  height: 360px;
  .row-no-margin > .row {
    margin: 0;
  }
`;

const ScrollBlock = styled.div`
  height: ${props => props.height ?? '340px'};
  padding-right: 10px;
  overflow-x: auto;
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
